export { SimilarPatientsModule } from './similar-patients.module';
